import { useAuthContext as useAuth } from 'context/AuthContext'

export default useAuth
